{
  "feedbackTextInputLabel": "Share Your Thoughts",
  "feedbackTextInputPlaceholder": "I wanted to share some feedback...",
  "likeOrDislikeWithFeatureName": "Like the {{featureName}}?",
  "linkTo": "Share Feedback",
  "other": "Something else",
  "subjectTextInputLabel": "Subject",
  "subjectTextInputPlaceholder": "(Choose topic)",
  "successMessage": "Your feedback has been received.",
  "description": "We'd love to hear your thoughts on how we can improve our product.",
  "title": "Share Feedback"
}
